customElements.get("related-products") || customElements.define("related-products", class extends HTMLElement {
  #t=!1;
  #e=null;
  #r=new Set;
  get #s() {
    return this.dataset.url?.match(/product_id=([0-9]+)/)?.[1];
  }
  async #a() {
    if (!this.#t && this.dataset.url) {
      this.#t = !0, this.toggleAttribute("data-loading", !0), this.#e?.abort(), this.#e = new AbortController;
      try {
        const t = await fetch(this.dataset.url, {
          signal: this.#e.signal
        });
        if (!t.ok) throw new Error(`HTTP ${t.status}`);
        const e = (new DOMParser).parseFromString(await t.text(), "text/html"), r = e.querySelector(this.tagName.toLowerCase());
        r?.innerHTML.trim() && (this.innerHTML = r.innerHTML);
        const s = e.querySelector("[data-labels]");
        s && this.closest('.shopify-section:not([id*="drawer"])')?.querySelectorAll("[data-labels]").forEach(t => t.innerHTML = s.innerHTML);
      } catch (t) {
        "AbortError" !== t.name && console.warn("Failed to fetch related products:", t);
      } finally {
        this.#t = !1, this.toggleAttribute("data-loading", !1);
      }
    }
  }
  #i(t) {
    return this.#r.add(t), t;
  }
  #o() {
    this.hasAttribute("data-lazy") && this.#i(new IntersectionObserver(([t]) => {
      t.isIntersecting && (this.#a(), this.#r.forEach(t => t.disconnect()));
    }, {
      rootMargin: `0px 0px ${window.innerHeight}px 0px`
    })).observe(this), this.hasAttribute("data-update") && this.#i(new MutationObserver(() => this.#a())).observe(this, {
      attributes: !0
    }), this.hasAttribute("data-pdp-height") && (this.classList.remove("hidden"), setTimeout(() => this.classList.remove("opacity-0"), 100));
  }
  async connectedCallback() {
    this.hasAttribute("data-lazy") || await this.#a(), this.#o();
  }
  disconnectedCallback() {
    this.#e?.abort(), this.#r.forEach(t => t.disconnect()), this.#r.clear();
  }
  update() {
    return this.#a();
  }
});